import * as CryptoJS from 'crypto-js';

const SECRET_KEY = 'Sip@SAKTI2025!&'; // Ideally, store this securely and do not hardcode

// Function to encrypt data
export const encryptData = (data: any) => {
  const jsonData = JSON.stringify(data);
  const cipherText = CryptoJS.AES.encrypt(jsonData, SECRET_KEY).toString();
  return cipherText;
};

// Function to decrypt data
export const decryptData = (cipherText: string) => {
  try {
    const bytes = CryptoJS.AES.decrypt(cipherText, SECRET_KEY);
    const plainText = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(plainText);
  } catch (error) {
    console.error("Decryption failed:", error);
    return null;
  }
};

// Usage example:
const sensitiveInfo = { username: 'user123', balance: 1000 };
const encrypted = encryptData(sensitiveInfo);
console.log('Encrypted:', encrypted);

const decrypted = decryptData(encrypted);
console.log('Decrypted:', decrypted);
